<script setup>
import Commons from '@/shared/utils/commons'
import TableList from '../others/TableList.vue'
import { ref } from 'vue'
import SlideDetailView from '../others/SlideDetailView.vue'
import OrderDetails from '../orders/OrderDetails.vue'

const cols = [
  {
    name: 'Commande',
    id: 'id',
    value(el) {
      const id = el?.id || '-'
      const truncated = id.length > 12 ? `${id.substring(0, 6)}...${id.substring(id.length - 4)}` : id
      return [truncated, el?.storeName || 'Resto Inconnu']
    },
  },
  {
    name: 'Date',
    id: 'orderDate',
    value(el) {
      return Commons.time(el?.orderDate)
    },
  },
  {
    name: 'Sous-total',
    id: 'subtotal',
    value(el) {
      return Commons.formatNumber(el?.subtotal || 0, { suffix: ' FCFA' })
    },
  },
  {
    name: 'Livraison',
    id: 'deliveryFee',
    value(el) {
      return Commons.formatNumber(el?.deliveryFee || 0, { suffix: ' FCFA' })
    },
  },
  {
    name: 'Service',
    id: 'serviceFee',
    value(el) {
      return Commons.formatNumber(el?.serviceFee || 0, { suffix: ' FCFA' })
    },
  },
  {
    name: 'Total',
    id: 'totalPrice',
    value(el) {
      return `<span class="font-bold text-green-700">${Commons.formatNumber(el?.totalPrice || 0, { suffix: ' FCFA' })}</span>`
    },
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/eye.png',
    onClick(el) {
      detailData.value = el
    },
    value() {},
  },
]

const detailData = ref(null)
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <div class="mb-6">
      <h1 class="text-3xl font-bold text-gray-800 mb-2">Rapport des Ventes</h1>
      <p class="text-gray-600">Détail financier des commandes livrées sur la plateforme</p>
    </div>

    <TableList
      title="Ventes réalisées"
      dataKey="orders"
      :queryParams="{ status: 'delivered' }"
      hasSearch
      :cols="cols"
    ></TableList>

    <SlideDetailView :isVisible="!!detailData" @hide="detailData = null">
      <OrderDetails v-if="detailData" :orderData="detailData"></OrderDetails>
    </SlideDetailView>
  </div>
</template>
